<template>
	<div style="display: none;">
		<div id="add-score-popup" class="popup_container popup_container--compact" style="display: none;">
			<AddScoreForm />
		</div>
		<div id="add-review-popup" class="popup_container" style="display: none;">
			<AddReviewForm />
		</div>
		<div id="add-score-success" class="popup_container popup_container--compact" style="display: none;">
			<div class="popup_head">
				<span>Спасибо за оценку</span>
			</div>
			<div class="popup_cont popup_cont--info">
				<span>Нам важно ваше мнение</span>
			</div>
		</div>
		<div id="add-review-success" class="popup_container popup_container--compact" style="display: none;">
			<div class="popup_head">
				<span>Спасибо за оценку и отзыв</span>
			</div>
			<div class="popup_cont popup_cont--info">
				<span>Нам важно ваше мнение</span>
			</div>
		</div>
	</div>

</template>

<script>
import AddScoreForm from "./AddScoreForm.vue";
import AddReviewForm from "./AddReviewForm.vue";
export default {
	name: 'ReviewModals',
	components: {
		AddScoreForm,
		AddReviewForm,
	}
}
</script>